/* global $ */

export default {
  /**
   * Loop through elements, and create event listeners for every element
   * @return {Void}
   */
  initialize() {
    setTimeout(() => {
      $('.js-alert').fadeOut(() => {
        $('.js-alert').remove();
      });
    }, 2000);
  },
};
